






















































































































import { Component, Emit, Prop, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { DataTable, Col } from '@/components/molecules/DataTable'
import { InputCodeAndTextField } from '@/components/molecules/InputCodeAndTextField'
import { UserMemo } from '@/api/models/user'
import { cloneDeep, each } from 'lodash'
import { SystemCode, systemCodeApi, SystemCodeWithKey } from '@/api'
import { InputCode } from '@/components/molecules/InputCode'
import { CODE_KEY } from '@/config'
import { InputDatePicker } from '@/components/molecules/InputDatePicker'
import AtomIconEraser from '@/components/atoms/AtomIconEraser/AtomIconEraser.vue'

@Component({
  components: {
    AtomIconEraser,
    InputCode,
    InputCodeAndTextField,
    InputDatePicker,
    DataTable
  }
})
export default class UserMemoEditTable extends ComponentVue {
  @Prop({
    type: Array,
    required: true
  })
  codes!: SystemCode[]

  @Prop({
    type: Array,
    required: true
  })
  items!: UserMemo[]

  @Prop({
    type: Number
  })
  height!: number

  internalItems: UserMemo[] = []

  @Watch('items', { immediate: true, deep: true })
  changeMemoItems(): void {
    this.internalItems = []
    each(this.items, (item: UserMemo) => {
      this.internalItems.push(cloneDeep(item))
    })
  }

  get userContactMemoSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.USER_CONTACT_MEMO.KEY)
  }

  get cols(): Col[] {
    return [
      {
        width: 50,
        items: [
          {
            name: 'descNo',
            align: 'right'
          }
        ]
      },
      {
        width: '36',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'memo',
            headerText: '内容'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'opacDisplay',
            headerText: 'OPAC表示'
          }
        ]
      },
      {
        width: '24',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'displayStartAndEndDate',
            headerText: 'OPAC表示期間'
          }
        ]
      },
      {
        width: '12',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'userCheckedTime',
            headerText: '利用者チェック日'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'date',
            headerText: '処理日'
          }
        ]
      },
      {
        width: '12',
        resizable: true,
        movable: true,
        items: [
          {
            name: 'place',
            headerText: '処理場所'
          }
        ]
      },
      {
        width: 75,
        resizable: true,
        movable: true,
        items: [
          {
            name: 'detail',
            align: 'center'
          }
        ]
      },
      {
        width: 30,
        resizable: true,
        movable: true,
        items: [
          {
            name: 'remove',
            align: 'center'
          }
        ]
      }
    ]
  }

  focus(index: number) {
    const memoCodeTextField: any = this.$refs[`memoCodeTextField${index}`]

    if (!memoCodeTextField) return

    memoCodeTextField.textField.atomTextField.focus()
  }

  onInputCode(systemCode: SystemCode, index: number) {
    this.debug('onInputCode', systemCode, index)
    this.$emit('input:memo-code', systemCode, index)
  }

  onInputMemo(memo: string, index: number) {
    this.debug('onInputMemo', memo, index)
    this.$emit('input:memo', memo, index)
  }

  onInputDisplayStartDate(displayStartDate: string, index: number) {
    this.debug('onInputDisplayStartDate', displayStartDate, index)
    this.$emit('input:displayStartDate', displayStartDate, index)
  }

  onInputDisplayEndDate(displayEndDate: string, index: number) {
    this.debug('onInputDisplayEndDate', displayEndDate, index)
    this.$emit('input:displayEndDate', displayEndDate, index)
  }

  onClickOpacDisplay(index: number) {
    this.debug('onClickOpacDisplay', index)
    this.$emit('click:opacDisplay', index)
  }

  onClickUserCheckedTimeDeleteFlag(index: number) {
    this.debug('onClickUserCheckedDateDeleteFlag', index)
    this.$emit('click:userCheckedDateDeleteFlag', index)
  }

  onClickUserCheckedTimeDeleteFlagCancel(index: number) {
    this.debug('onClickUserCheckedTimeDeleteFlagCancel', index)
    this.$emit('click:userCheckedTimeDeleteFlagCancel', index)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  @Emit('click:detail')
  onClickDetail(index: number): number {
    return index
  }

  @Emit('click:remove')
  onClickRemove(index: number): number {
    return index
  }

  @Emit('click:add')
  onClickAddRow(): void {}
}
